// Generated by tours-package/scripts/train-custom-quote-model.py.
// Do not edit by hand; rerun the trainer and review the JSON artifact.
export const CUSTOM_TOUR_QUOTE_MODEL_ARTIFACT = {
  schemaVersion: 1,
  modelVersion: 'tours-custom-svr-poly-v1',
  currency: 'USD',
  training: {
    sourceCsv: 'tours-package/data/tago-tours-vehicle-catalog.csv',
    sourceCsvSha256: '65c32dcd2603d8208e98bbcff72f3f28cea21d1c3166c658bd8a1e29f100b9b8',
    sampleCount: 23,
    scope: {
      country: 'SV',
      excludedTourIds: ['tourexp_ruta_maya_centroamerica'],
      minimumPassengers: 10,
      vehicleTypes: ['bus', 'coaster', 'microbus'],
    },
    continuousFeatures: ['capacidad_pasajeros', 'numero_paradas', 'distancia_real_terrestre_km'],
    featureOrder: [
      'capacidad_pasajeros',
      'numero_paradas',
      'distancia_real_terrestre_km',
      'tipo_veh_bus',
      'tipo_veh_coaster',
      'tipo_veh_microbus',
    ],
    scaler: {
      mean: [26.17391304347826, 3.391304347826087, 90.54176521739127],
      scale: [12.11413896853426, 0.48804226784007926, 62.491913868140884],
    },
    domain: {
      distanceKm: {
        min: 6.323,
        max: 211.8462,
      },
      stopCount: {
        min: 3,
        max: 4,
      },
    },
  },
  model: {
    kind: 'svr_poly',
    degree: 2,
    C: 1000.0,
    epsilon: 1.0,
    gamma: 0.2608695652173913,
    coef0: 0.0,
    supportVectors: [
      [-0.9223860707312193, 1.2472191289246473, 0.34703265495065716, 0.0, 0.0, 1.0],
      [-0.014356203435505421, 1.2472191289246473, 0.34703265495065716, 0.0, 1.0, 0.0],
      [1.554059021893455, 1.2472191289246473, 0.34703265495065716, 1.0, 0.0, 0.0],
      [-0.9223860707312193, 1.2472191289246473, 0.005031607501607195, 0.0, 0.0, 1.0],
      [-0.014356203435505421, 1.2472191289246473, 0.005031607501607195, 0.0, 1.0, 0.0],
      [1.554059021893455, 1.2472191289246473, 0.005031607501607195, 1.0, 0.0, 0.0],
      [-0.9223860707312193, -0.8017837257372732, -0.11555679399783622, 0.0, 0.0, 1.0],
      [-0.9223860707312193, -0.8017837257372732, -0.939665015561768, 0.0, 0.0, 1.0],
      [-0.9223860707312193, 1.2472191289246473, -0.99150852297676, 0.0, 0.0, 1.0],
      [-0.014356203435505421, 1.2472191289246473, -0.99150852297676, 0.0, 1.0, 0.0],
      [1.554059021893455, 1.2472191289246473, -0.99150852297676, 1.0, 0.0, 0.0],
      [-0.9223860707312193, -0.8017837257372732, -0.6047240815368473, 0.0, 0.0, 1.0],
      [-0.014356203435505421, -0.8017837257372732, -0.6047240815368473, 0.0, 1.0, 0.0],
      [1.554059021893455, -0.8017837257372732, -0.6047240815368473, 1.0, 0.0, 0.0],
      [-0.9223860707312193, -0.8017837257372732, 1.9411220952292065, 0.0, 0.0, 1.0],
      [-0.014356203435505421, -0.8017837257372732, 1.9411220952292065, 0.0, 1.0, 0.0],
      [1.554059021893455, -0.8017837257372732, 1.9411220952292065, 1.0, 0.0, 0.0],
      [-0.9223860707312193, -0.8017837257372732, 0.8303575866167092, 0.0, 0.0, 1.0],
      [-0.014356203435505421, -0.8017837257372732, 0.8303575866167092, 0.0, 1.0, 0.0],
      [1.554059021893455, -0.8017837257372732, 0.8303575866167092, 1.0, 0.0, 0.0],
      [-0.9223860707312193, -0.8017837257372732, -1.3476746030709583, 0.0, 0.0, 1.0],
      [-0.014356203435505421, -0.8017837257372732, -1.3476746030709583, 0.0, 1.0, 0.0],
    ],
    dualCoefficients: [
      353.84397907015455, 1000.0, 1000.0, -1000.0, -1000.0, -1000.0, -1000.0, 1000.0,
      424.4642373455005, 125.48811741967928, 85.08343231301755, 157.90960269155144, 1000.0,
      639.2812924688604, -393.79963409466967, 36.074922080526974, 551.8943271603501, 1000.0,
      -353.797989962803, -1000.0, -1000.0, -626.4422864921705,
    ],
    intercept: 309.3893714937329,
  },
  calibration: {
    upliftRate: 0.0974,
    rounding: 'ceil-cent',
    basis: 'Owner-calibrated held-out SVR polynomial evaluation (+9.74%).',
  },
  fixtures: [
    {
      input: {
        vehicleType: 'microbus',
        vehicleCapacity: 15,
        stopCount: 4,
        distanceKm: 112.2285,
      },
      rawPredictionUsd: 228.99963223798042,
      safePriceCents: 25131,
    },
    {
      input: {
        vehicleType: 'bus',
        vehicleCapacity: 45,
        stopCount: 4,
        distanceKm: 28.5805,
      },
      rawPredictionUsd: 454.0001337759527,
      safePriceCents: 49822,
    },
    {
      input: {
        vehicleType: 'coaster',
        vehicleCapacity: 26,
        stopCount: 3,
        distanceKm: 6.323,
      },
      rawPredictionUsd: 251.00043233304638,
      safePriceCents: 27545,
    },
  ],
} as const
